import { ComponentProps, JSX } from "solid-js";
import c from "class-c";
import { Motion } from "solid-motionone";

import createInitial from "../signals/createInitial";

import styles from "./Fade.module.scss";

declare namespace Fade {
  type Direction = keyof typeof translationByDirection;

  type Props = {
    class?: string;
    style?: JSX.CSSProperties;
    children: JSX.Element;
    transition?: JSX.CSSProperties["transition"];
    direction?: Direction;
    show?: unknown;
  };
}

const translationByDirection = {
  up: [0, -1],
  right: [1, 0],
  down: [0, 1],
  left: [-1, 0],
} as const;

function Fade({
  direction,
  transition,
  style,
  show = true,
  ...props
}: D<Fade.Props>) {
  const initial = createInitial();

  return (
    <div
      style={{
        transition: transition || "var(--normal-s)",
        opacity: !initial() && show ? 1 : 0,
        transform:
          !show && direction
            ? (() => {
                const [x, y] = translationByDirection[direction];
                return `translate(${x * 100}%, ${y * 100}%)`;
              })()
            : undefined,
        ...style,
      }}
      {...props}
    />
  );
}

declare namespace Fade.Presence {
  type Props = ComponentProps<typeof Motion.div>;
}

Fade.Presence = Presence;
function Presence({
  children,
  class: className,
  ...props
}: D<Fade.Presence.Props>) {
  return (
    <Motion.div
      class={c`${styles.presence} ${className}`}
      initial={{ opacity: -0.5 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: -0.5 }}
      {...props}
    >
      {children}
    </Motion.div>
  );
}

export default Fade;
